import React, { FunctionComponent } from "react";

import styled from "styled-components";

import { Option } from "../../models/select";

import FilterItem from "./filterItem";

interface IProps {
  options: Option[];
  title: string;
  width: number;
  updateSelected: (option: Option) => void;
}

const FilterColumn: FunctionComponent<IProps> = ({
  options,
  title,
  width,
  updateSelected
}) => {
  return (
    <StyledColumn width={width}>
      <FilterColumnTitle> {title} </FilterColumnTitle>
      {options.map(option => {
        const { name, svg, color, selected } = option;
        return (
          <FilterItem
            key={name}
            name={name}
            svg={svg}
            color={color}
            selected={selected}
            updateSelected={() => {
              updateSelected(option);
            }}
          />
        );
      })}
    </StyledColumn>
  );
};

interface Width {
  width: number;
}

const StyledColumn = styled.div<Width>`
  display: flex column;
  width: ${p => p.width}px;
  justify-content: flex-start;
` as FunctionComponent<Width>;

const FilterColumnTitle = styled.div`
  display: inline-block;
  font-size: 12px;
  padding: 0px;
  font-weight: 500;
  line-height: 1.33;
  color: #5d5d5d;
`;

export default FilterColumn;
